import baseAPI from "@/http";

const router = "api/log";

export const logAPI = {
  downloadArquivo: filtro =>
    baseAPI.post(router + "/arquivo-log", filtro, { responseType: "blob" })
};
